import bgImage7 from '@iso/assets/images/background/signin7.png';

export const handleShowRandomImage = (images = null, arrIndex = []) => {
    var backgroundImage = images && images.length ? images: [bgImage7];
    const randomIndex = Math.floor(Math.random() * backgroundImage.length)
    var item = backgroundImage[randomIndex];
    arrIndex[0] = randomIndex
    return item;
}